import { render, staticRenderFns } from "./CallEvent.vue?vue&type=template&id=189a33a9"
import script from "./CallEvent.vue?vue&type=script&lang=js"
export * from "./CallEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports